// import styled from 'styled-components';
// import { darken } from 'polished';

// const Item = styled.div`
//   flex: 1;
//   display: ${(props) => (props.visible ? 'flex' : 'none')};
//   flex-direction: column;
//   background: ${(props) => props.color};
//   box-shadow: inset 0 0 1em #00000026;
//   position: relative;

//   width: 100%;
//   max-width: 400px;
//   height: 100%;
//   overflow-y: auto;

//   ::before {
//     content: '';
//     position: absolute;
//     left: 0;
//     top: 50px;
//     display: block;
//     border-right: 1px solid ${(props) => `${darken(0.1, props.color)}`};
//     border-bottom: 1px solid ${(props) => `${darken(0.1, props.color)}`};
//     background: ${(props) => `${darken(0.08, props.color)}`};
//     width: 25px;
//     height: 25px;
//     transform: translate(-50%, -50%) rotate(-45deg);
//   }
// `;

// Item.Title = styled.div`
//   padding: 40px 40px 5px;

//   > div {
//     display: flex;
//     align-items: center;
//     color: #2c405a;

//     > button {
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       border: 0;
//       background: none;
//       margin-right: 5px;
//       height: 30px;
//       width: 30px;
//       border-radius: 50%;

//       :hover {
//         background: ${darken(0.05, '#dde3f1')};
//       }
//     }
//   }

//   > form {
//     border-bottom: 1px solid rgba(44, 64, 90, 0.2);
//   }
// `;

// Item.Wrapper = styled.ul`
//   color: #000;
//   font-size: 18px;
//   transform: color 1s;

//   > li {
//     > a {
//       display: flex;
//       padding: 15px 40px;
//       color: #2c405a;
//     }

//     a.disabled-link {
//       color: rgba(44, 64, 90, 0.6);
//       pointer-events: none;
//     }

//     a:hover {
//       background: ${darken(0.05, '#dde3f1')};
//     }

//     a:visited,
//     a:active {
//       color: rgba(44, 64, 90, 0.6);
//     }
//   }
// `;

// export { Item };

// import styled, { css } from 'styled-components';
// import { darken, readableColor } from 'polished';

// const scrollThumb = css`
//   &::-webkit-scrollbar {
//     width: 6px;
//   }
//   &::-webkit-scrollbar-track {
//     background: transparent;
//   }
//   &::-webkit-scrollbar-thumb {
//     background-color: ${(props) => darken(0.2, props.color)};
//     border-radius: 3px;
//   }
// `;

// const Item = styled.div`
//   flex: 1;
//   display: ${(props) => (props.visible ? 'flex' : 'none')};
//   flex-direction: column;
//   background: ${(props) => props.color};
//   color: ${(props) => readableColor(props.color)};
//   box-shadow: inset 0 0 1em rgba(0, 0, 0, 0.15);
//   width: 100%;
//   max-width: 400px;
//   height: 100%;
//   overflow-y: auto;
//   position: relative;
//   ${scrollThumb}

//   /* “Setinha” de destaque */
//   &::before {
//     content: '';
//     position: absolute;
//     left: 0;
//     top: 60px;
//     width: 20px;
//     height: 20px;
//     background: ${(props) => darken(0.08, props.color)};
//     transform: translate(-50%, -50%) rotate(-45deg);
//     border-right: 1px solid ${(props) => darken(0.1, props.color)};
//     border-bottom: 1px solid ${(props) => darken(0.1, props.color)};
//   }
// `;

// Item.Title = styled.div`
//   padding: 32px 24px 16px;
//   .header {
//     display: flex;
//     align-items: center;

//     h2 {
//       margin: 0;
//       font-size: 1.5rem;
//       flex: 1;
//     }

//     button {
//       background: none;
//       border: none;
//       padding: 6px;
//       margin-right: 8px;
//       border-radius: 50%;
//       transition: background 0.2s;

//       &:hover {
//         background: ${(props) => darken(0.05, '#dde3f1')};
//       }
//     }
//   }
// `;

// const SearchWrapper = styled.div`
//   margin-top: 12px;
//   display: flex;
//   align-items: center;
//   background: #fff;
//   border: 1px solid rgba(44, 64, 90, 0.2);
//   border-radius: 24px;
//   padding: 4px 12px;
//   transition: border-color 0.2s, box-shadow 0.2s;

//   &:focus-within {
//     border-color: ${(props) => darken(0.2, '#dde3f1')};
//     box-shadow: 0 0 0 2px ${(props) => darken(0.3, '#dde3f1')};
//   }

//   svg {
//     margin-right: 8px;
//     color: rgba(44, 64, 90, 0.6);
//   }

//   input {
//     border: none;
//     flex: 1;
//     font-size: 1rem;
//     outline: none;
//     background: transparent;
//     color: inherit;
//     ::placeholder {
//       color: rgba(44, 64, 90, 0.4);
//     }
//   }
// `;

// Item.Wrapper = styled.ul`
//   list-style: none;
//   margin: 0;
//   padding: 0;

//   li + li {
//     border-top: 1px solid rgba(44, 64, 90, 0.1);
//   }

//   a {
//     display: block;
//     padding: 14px 24px;
//     font-size: 1rem;
//     color: #2c405a;
//     text-decoration: none;
//     transition: background 0.15s, color 0.15s;

//     &.disabled-link {
//       color: rgba(44, 64, 90, 0.4);
//       pointer-events: none;
//     }

//     &.selected {
//       background: ${(props) => darken(0.05, props.color)};
//       border-left: 4px solid ${(props) => darken(0.15, props.color)};
//       padding-left: 20px;
//       color: ${(props) => readableColor(darken(0.05, props.color))};
//       font-weight: 600;
//     }

//     &:hover {
//       background: ${(props) => darken(0.03, props.color)};
//     }
//   }
// `;

// export { Item, SearchWrapper };

// styles.js
import styled, { css } from 'styled-components';
import { darken } from 'polished';

// const BASE_COLOR = '#eef1f8';
// const TEXT_COLOR = '#020617';

const BASE_COLOR = '#020617';
const TEXT_COLOR = '#cbd5e1';

const scrollThumb = css`
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${darken(0.2, BASE_COLOR)};
    border-radius: 3px;
  }
`;

const Item = styled.div`
  flex: 1;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  flex-direction: column;
  background: ${BASE_COLOR};
  color: ${TEXT_COLOR};
  box-shadow: inset 0 0 1em rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 400px;
  height: 100%;
  overflow-y: auto;
  position: relative;
  ${scrollThumb}

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 60px;
    width: 20px;
    height: 20px;
    background: ${darken(0.08, BASE_COLOR)};
    transform: translate(-50%, -50%) rotate(-45deg);
    border-right: 1px solid ${darken(0.1, BASE_COLOR)};
    border-bottom: 1px solid ${darken(0.1, BASE_COLOR)};
  }
`;

Item.Title = styled.div`
  padding: 32px 24px 16px;

  .header {
    display: flex;
    align-items: center;

    h2 {
      margin: 0;
      font-size: 1.5rem;
      flex: 1;
      color: #f1f5f9;
    }

    button {
      background: none;
      border: none;
      padding: 6px;
      margin-right: 8px;
      border-radius: 50%;
      transition: background 0.2s;

      &:hover {
        background: ${darken(0.05, '#dde3f1')};
      }
    }
  }
`;

export const SearchWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid rgba(44, 64, 90, 0.2);
  border-radius: 8px;
  padding: 2px 12px;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus-within {
    border-color: ${darken(0.2, '#dde3f1')};
    box-shadow: 0 0 0 2px ${darken(0.3, '#dde3f1')};
  }

  svg {
    margin-right: 8px;
    color: rgba(44, 64, 90, 0.6);
  }

  input {
    border: none;
    flex: 1;
    font-size: 1rem;
    outline: none;
    background: transparent;
    color: inherit;

    &::placeholder {
      color: rgba(44, 64, 90, 0.4);
    }
  }
`;

Item.Wrapper = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li + li {
    /* border-top: 1px solid rgba(44, 64, 90, 0.1); */
    border-top: 1px solid #1e293b;
  }

  a {
    display: block;
    padding: 14px 24px;
    font-size: 1rem;
    color: ${TEXT_COLOR};
    text-decoration: none;
    /* transition: background 0.15s, color 0.15s; */

    transition: background 0.3s ease-in-out, padding-left 0.3s ease-in-out;

    &.disabled-link {
      color: rgba(44, 64, 90, 0.4);
      pointer-events: none;
    }

    &.selected {
      background: ${darken(0.05, BASE_COLOR)};
      border-left: 4px solid ${darken(0.15, BASE_COLOR)};
      padding-left: 20px;
      color: #ffffff;
      font-weight: 600;
    }

    &:hover {
      background: ${darken(0.03, BASE_COLOR)};
      padding-left: 34px;
      /* box-shadow: 1px 2px 5px 1px #949494; */
      box-shadow: 1px 2px 5px 1px #1e293b;
    }
  }
`;

export { Item };
